// Reagendamentos — fila + sugerir/aplicar novo horário (API real).
// Cutover Fatia 3: fala com /clinica/reschedules (+ :id/suggest, :id/apply).
// Adapta o payload canônico (RescheduleRequest + appointment) para o shape da
// view. Status 'pendente'/'sugerido' é derivado da presença de suggested_at
// (no backend a fila é sempre `pending`; `applied` já sai da fila).
import AXIOS from "@/services/axios";
import { initialsOf, avatarClassFor, slotLabel } from "./helpers";

function adaptReschedule(r, i) {
  const appt = r.appointment || {};
  const patient = appt.patient || {};
  return {
    id: r.id,
    patientId: patient.id,
    patientName: patient.name,
    initials: initialsOf(patient.name),
    avatarClass: avatarClassFor(i),
    doctorId: appt.doctor_id,
    doctorName: appt.doctor_name,
    oldSlot: slotLabel(appt.scheduled_at),
    reason: r.reason,
    status: r.suggested_at ? "sugerido" : "pendente",
    suggested: r.suggested_at ? { datetime: r.suggested_at } : null
  };
}

export class ClinicReschedules {
  static list() {
    return AXIOS.get("clinica/reschedules").then(res => ({
      data: (res.data || []).map(adaptReschedule)
    }));
  }

  /** Sugere um horário ao paciente (não sai da fila; vira 'sugerido'). */
  static suggest(id, slot) {
    return AXIOS.post(`clinica/reschedules/${id}/suggest`, {
      suggested_at: slot && slot.datetime
    }).then(res => ({
      data: { id, suggested: { datetime: res.data.suggested_at } }
    }));
  }

  /** Aplica o novo horário → move a consulta e resolve o pedido. */
  static apply(id, slot) {
    return AXIOS.post(`clinica/reschedules/${id}/apply`, {
      at: slot && slot.datetime
    }).then(() => ({ data: { id, status: "agendada" } }));
  }
}

export default ClinicReschedules;
